import { render, staticRenderFns } from "./UpdateTechnicianPositionModal.vue?vue&type=template&id=5e96f0e4&scoped=true&"
import script from "./UpdateTechnicianPositionModal.vue?vue&type=script&lang=js&"
export * from "./UpdateTechnicianPositionModal.vue?vue&type=script&lang=js&"
import style0 from "./UpdateTechnicianPositionModal.vue?vue&type=style&index=0&id=5e96f0e4&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e96f0e4",
  null
  
)

export default component.exports